"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _backgroundImage = _interopRequireDefault(require("./background-image"));

var _textBlockCta = _interopRequireDefault(require("./text-block-cta"));

var _infoHeader = require("./info-header.propTypes");

var _infoHeader2 = _interopRequireDefault(require("./info-header.css"));

var InfoHeader = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(InfoHeader, _React$Component);

  InfoHeader.resourceType = function resourceType() {
    return 'InfoHeader_1_0_0';
  };

  function InfoHeader(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleCTAClick = _this.handleCTAClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = InfoHeader.prototype;

  _proto.handleCTAClick = function handleCTAClick() {
    console.log('Make An Enquiry');
  };

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        theme = _this$props.theme;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _infoHeader2["default"].outerContainer,
      automation: "infoHeaderContainer"
    }, /*#__PURE__*/_react["default"].createElement(_backgroundImage["default"], {
      data: data
    }), /*#__PURE__*/_react["default"].createElement(_textBlockCta["default"], {
      data: data,
      theme: theme,
      handleCTAClick: this.handleCTAClick
    }));
  };

  return InfoHeader;
}(_react["default"].Component);

exports["default"] = InfoHeader;
InfoHeader.displayName = 'InfoHeader';